import Vue from 'vue'
import { i18n, translate as $t } from '../language/i18n_mounting' // 多语言

import Router from 'vue-router'
import Layout from '@/components/layout'
import Coupon from '@/components/getcoupon'
import Index from '@/pages/home/index'
import Search from '@/pages/list/search'
import ShopCardHobby from '@/pages/list/index'
import ShopBuyNow from '@/pages/list/buynow'
import Login from '@/pages/shared/login'
import Register from '@/pages/shared/register'
import ForgotPassword from '@/pages/shared/forgot'
import NotFind from '@/pages/shared/notfind'
import ShareSeller from '@/pages/shared/shareseller'
import ShareCard from '@/pages/shared/sharecard'
import ShareCoupon from '@/pages/shared/sharecoupon'
import Seller from '@/pages/seller/index'
import SellerList from '@/pages/seller/list'
import CardDetails from '@/pages/carddetails/index'
import CardStoreDetails from '@/pages/carddetails/store'
// import BuyNow from '@/pages/carddetails/buynow'
import AppPay from '@/pages/pay/apppay'
import AppOtherPay from '@/pages/pay/appotherpay'
import Cart from '@/pages/pay/cart'
import Checkout from '@/pages/pay/checkout'
import ChpCheckout from '@/pages/pay/chpcheckout'
import WareCheckout from '@/pages/pay/warecheckout'
import CartCheckout from '@/pages/pay/cartcheckout'
import StoreCheckout from '@/pages/pay/storecheckout'
import MyCardHoddy from '@/pages/user/tabslist'
import Recently from '@/pages/user/recently'
import Bids from '@/pages/user/bids'
import PurchaseHistory from '@/pages/user/purchase'
import MallOrder from '@/pages/user/mallorder'
import Warehouse from '@/pages/user/warehouse'
import Watching from '@/pages/user/watch'
import TaxRefund from '@/pages/user/taxrefund'
import Blocked from '@/pages/user/blocked'
import SavedSearch from '@/pages/user/search'
import SavedSellers from '@/pages/user/sellers'
import AccountSettings from '@/pages/user/setting'
import Activity from '@/pages/user/activity'
import OrderDetail from '@/pages/user/detail'
import OrderStore from '@/pages/user/malldetail'
import WareDetail from '@/pages/user/waredetail'
import BidHistory from '@/pages/user/bidhistory'
import OfferHistory from '@/pages/user/offerhistory'
import Chp from '@/pages/user/chp'
import Coupons from '@/pages/user/coupons'
import Messages from '@/pages/messages/index'
import MessagesDetail from '@/pages/messages/detail'
import Feedback from '@/pages/feedback/index'
import Privacy from '@/pages/terms/privacy'
import Account from '@/pages/terms/account'
import Customer from '@/pages/terms/customer'
import AppPrivacy from '@/pages/terms/appprivacy'
import Company from '@/pages/Company/companyinfo'
import AppCompany from '@/pages/Company/appcompanyinfo'

import NewPlace from '@/components/activity/newplace'
import AppNewPlace from '@/components/activity/appnewplace'
import TradingRules from '@/components/activity/tradingrules' //鸽子规则广告
import AppTradingRules from '@/components/activity/apptradingrules' //鸽子规则广告 app
import FreeAway from '@/components/activity/freeaway'
import AppFreeAway from '@/components/activity/appfreeaway'
import HowCoupon from '@/components/activity/howcoupon'
import Oversea from '@/components/activity/oversea'
import AppOversea from '@/components/activity/appoversea'
import Purchase from '@/components/activity/purchase'
import AppPurchase from '@/components/activity/apppurchase'
import BecomeSeller from '@/components/activity/becomeseller'
import BecomeAppSeller from '@/components/activity/appbecomeseller'
import ImportantUpdate from '@/components/activity/importantupdate'
import AppImportantUpdate from '@/components/activity/appimportantupdate'
import AppActivityDetail from '@/components/activity/appactivitydetail'
import ActivityDetail from '@/components/activity/activitydetail'

// 信用卡
import CreditCard from '@/pages/pay/creditcard'

//官方介入维权结果
import CaseOutcome from '@/pages/pay/caseoutcome'


// festival 节日
import Midautumn from '@/components/activity/festival/midautumn'
import AppMidautumn from '@/components/activity/festival/appmidautumn'
// festival 结束
// 
// 
// promotions 活动
import Promotion from '@/components/activity/promotions/promotion'

// promotions 结束
// 
// Merchants settled  商家入驻
import Merchants from '@/pages/terms/merchants'

// 新人认证回调
import authentication from '@/components/authenticationcallback'

Vue.use(Router)
const originalPush = Router.prototype.push
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [{
      path: '/',
      name: "layout",
      component: Layout,
      children: [{
          path: '/',
          name: "home",
          component: Index,
          meta: {
            title: i18n.t('title.homeTitle')
          },
        },
        {
          path: '/market/:id?',
          name: "market",
          component: Search,
          meta: {
            title: i18n.t('title.searchResults')
          }
        },
        {
          path: '/list/:id?',
          name: "CardHobby",
          component: ShopCardHobby,
          meta: {
            title: i18n.t('title.cardHobbyShop')
          }
        },
        {
          path: '/buynow/:id?',
          name: "buynow",
          component: ShopBuyNow,
          meta: {
            title: i18n.t('title.cardHobbyShop')
          }
        },
        {
          path: '/seller/detail/:id?',
          name: "seller",
          component: Seller,
          meta: {
            title: i18n.t('title.cardHobbyShore')
          }
        },
        {
          path: '/seller/list',
          name: "seller",
          component: SellerList,
          meta: {
            title: i18n.t('title.allStores')
          }
        },
        {
          path: '/Company/companyinfo',
          name: "companyinfo",
          component: Company,
          meta: {
            title: i18n.t('title.companyInfo')
          }
        },
        {
          path: '/mycardhobby/recently',
          name: "MyCardHoddy",
          component: MyCardHoddy,
          children: [{
              path: '/mycardhobby/recently',
              name: "recently",
              component: Recently,
              meta: {
                title: i18n.t('title.recentlyViewed')
              }
            },
            {
              path: '/mycardhobby/bids',
              name: "bids",
              component: Bids,
              meta: {
                title: i18n.t('title.bidAOffer')
              }
            },
            {
              path: '/mycardhobby/purchase',
              name: "purchase",
              component: PurchaseHistory,
              meta: {
                title: i18n.t('title.purchaseHistory')
              }
            },
            {
              path: '/mycardhobby/mallorder',
              name: "mallOrders",
              component: MallOrder,
              meta: {
                title: i18n.t('title.purchaseHistory')
              }
            },
            {
              path: '/mycardhobby/watch',
              name: "watch",
              component: Watching,
              meta: {
                title: i18n.t('title.watchlist')
              }
            },
            {
              path: '/mycardhobby/search',
              name: "search",
              component: SavedSearch,
              meta: {
                title: i18n.t('title.savedSearch')
              }
            },
            {
              path: '/mycardhobby/taxrefund',
              name: "TaxRefund",
              component: TaxRefund,
              meta: {
                title: i18n.t('title.taxrefund')
              }
            },
            {
              path: '/mycardhobby/block',
              name: "Block",
              component: Blocked,
              meta: {
                title: i18n.t('title.taxrefund')
              }
            },
            {
              path: '/mycardhobby/activity/:id?',
              name: "Activity",
              component: Activity,
              meta: {
                title: i18n.t('base.Promotions')
              }
            },
            {
              path: '/mycardhobby/sellers',
              name: "sellers",
              component: SavedSellers,
              meta: {
                title: i18n.t('title.savedSellers')
              }
            },
            {
              path: '/mycardhobby/setting',
              name: "Account Settings",
              component: AccountSettings,
              meta: {
                title: i18n.t('title.accountSettings')
              }
            },
            {
              path: '/mycardhobby/warehouse',
              name: "Warehouse",
              component: Warehouse,
              meta: {
                title: i18n.t('title.overseaWarehouse')
              }
            },
            {
              path: '/mycardhobby/chp',
              name: "Chp",
              component: Chp,
              meta: {
                title: i18n.t('title.chp')
              }
            },
            {
              path: '/mycardhobby/coupons',
              name: "coupons",
              component: Coupons,
              meta: {
                title: i18n.t('title.coupons')
              }
            },
          ]
        },
        {
          path: '/mycardhobby/bidhistory/:id?',
          name: "BidHistory",
          component: BidHistory,
          meta: {
            title: i18n.t('title.bidHistory')
          }
        },
        {
          path: '/mycardhobby/offerhistory/:id?',
          name: "OfferHistory",
          component: OfferHistory,
          meta: {
            title: i18n.t('title.offerHistory')
          }
        },
        {
          path: '/mycardhobby/detail/:id?',
          name: "OrderDetail",
          component: OrderDetail,
          meta: {
            title: i18n.t('title.orderDetail')
          }
        },
        {
          path: '/mycardhobby/orderdetail/:id?',
          name: "OrderStore",
          component: OrderStore,
          meta: {
            title: i18n.t('title.orderDetail')
          }
        },
        {
          path: '/mycardhobby/waredetail/:id?',
          name: "WareDetail",
          component: WareDetail,
          meta: {
            title: i18n.t('title.orderDetail')
          }
        },
        {
          path: '/carddetails/:id?',
          name: "carddetails",
          component: CardDetails,
          meta: {
            title: i18n.t('title.cardDetails')
          }
        },
        {
          path: '/storedetails/:id?',
          name: "CardStoreDetails",
          component: CardStoreDetails,
          meta: {
            title: i18n.t('title.cardDetails')
          }
        },
        {
          path: '/pay/outcome/:id',
          name: "Case Outcome",
          component: CaseOutcome,
          meta: {
            title: 'Case Outcome'
          }
        },
        {
          path: '/pay/cart',
          name: "Shopping cart",
          component: Cart,
          meta: {
            title: i18n.t('title.cart')
          }
        },
        {
          path: '/pay/checkout/:id?',
          name: "Checkout",
          component: Checkout,
          meta: {
            title: i18n.t('title.checkout')
          }
        },
        {
          path: '/pay/chp',
          name: "ChpChange",
          component: ChpCheckout,
          meta: {
            title: i18n.t('title.checkout')
          }
        },
        {
          path: '/pay/warehouse/:id?',
          name: "warehouseChange",
          component: WareCheckout,
          meta: {
            title: i18n.t('title.checkout')
          }
        },
        {
          path: '/pay/storecheckout/:id?',
          name: "StoreCheckout",
          component: StoreCheckout,
          meta: {
            title: i18n.t('title.checkout')
          }
        },
        {
          path: '/pay/cartcheckout/:id?',
          name: "CartCheckout",
          component: CartCheckout,
          meta: {
            title: i18n.t('title.checkout')
          }
        },
        {
          path: '/messages',
          name: "messages",
          component: Messages,
          meta: {
            title: i18n.t('title.notification')
          }
        },
        {
          path: '/messages/detail/:id?',
          name: "messages",
          component: MessagesDetail,
          meta: {
            title: i18n.t('title.notification')
          }
        },
        {
          path: '/feedback/:id?',
          name: "feedback",
          component: Feedback,
          meta: {
            title: i18n.t('title.feedback')
          }
        },
        {
          path: '/terms/privacy',
          name: "privacy",
          component: Privacy,
          meta: {
            title: i18n.t('title.rulesAPolicies')
          }
        },
        {
          path: '/terms/account',
          name: "account",
          component: Account,
          meta: {
            title: i18n.t('title.cancelAccount')
          }
        },
        {
          path: '/terms/customer',
          name: "Customer",
          component: Customer,
          meta: {
            title: i18n.t('title.customerService')
          }
        },
        {
          path: '/terms/place',
          name: "NewPlace",
          component: NewPlace,
          meta: {
            title: i18n.t('title.newPlaceToBuy')
          }
        },
        {
          path: '/terms/traderules',
          name: "TradingRules",
          component: TradingRules,
          meta: {
            title: i18n.t('title.tradingRules')
          }
        },
        {
          path: '/terms/process',
          name: "Processintroduction",
          component: Oversea,
          meta: {
            title: i18n.t('title.processIntroduction')
          }
        },
        {
          path: '/terms/purchase',
          name: "Processintroduction",
          component: Purchase,
          meta: {
            title: i18n.t('title.processIntroduction')
          }
        },
        {
          path: '/terms/becomeseller',
          name: "BecomeSeller",
          component: BecomeSeller,
          meta: {
            title: i18n.t('title.becomeSeller')
          }
        },
        {
          path: '/terms/importantUpdate',
          name: "Important Update",
          component: ImportantUpdate,
          meta: {
            title: i18n.t('title.importantUpdate')
          }
        },
        // 节日
        {
          path: '/terms/hoilday/:id?',
          name: "Notice",
          component: Midautumn,
          meta: {
            title: i18n.t('base.notice')
          }
        },
        // 节日结束
        // 入驻回调
        {
          path: '/terms/merchants',
          name: "Merchants",
          component: Merchants,
          meta: {
            title: 'Become a Seller'
          }
        },
        // 新人认证回调
        {
          path: '/authentication',
          name: "Authentication",
          component: authentication,
          meta: {
            title: 'ID Verification'
          }

        },
      ]
    },
    {
      path: '/Company/appcompanyinfo',
      name: "appcompanyinfo",
      component: AppCompany,
      meta: {
        title: i18n.t('title.companyInfo')
      }
    },
    {
      path: '/creditcards',
      name: "creditcards",
      component: CreditCard,
      meta: {
        title: 'Authorize.Net'
      }
    },
    {
      path: '/login',
      name: "Login",
      component: Login,
      meta: {
        title: i18n.t('title.login')
      }
    },
    {
      path: '/register',
      name: "Register",
      component: Register,
      meta: {
        title: i18n.t('title.register')
      }
    },
    {
      path: '/forgot',
      name: "Forgot",
      component: ForgotPassword,
      meta: {
        title: i18n.t('title.forgotPwd')
      }
    },
    {
      path: '/payapp',
      name: "payapp",
      component: AppPay,
      meta: {
        title: i18n.t('title.payNow')
      }
    },
    {
      path: '/payother',
      name: "payother",
      component: AppOtherPay,
      meta: {
        title: 'Paying'
      }
    },
    {
      path: '/coupon',
      name: "coupon",
      component: Coupon,
      meta: {
        title: i18n.t('title.coupon')
      }
    }, //ShareSeller,ShareCard
    {
      path: '/shareseller/:id',
      name: "ShareSeller",
      component: ShareSeller,
      meta: {
        title: i18n.t('title.shareSeller')
      }
    },
    {
      path: '/sharecard/:id',
      name: "ShareCard",
      component: ShareCard,
      meta: {
        title: i18n.t('title.v')
      }
    },
    {
      path: '/sharecoupon',
      name: "ShareCoupon",
      component: ShareCoupon,
      meta: {
        title: i18n.t('title.shareCoupon')
      }
    },
    {
      path: '/app/privacy',
      name: "privacy",
      component: AppPrivacy,
      meta: {
        title: i18n.t('title.rulesAPolicies')
      }
    },
    {
      path: '/freeaway',
      name: "freeaway",
      component: FreeAway,
      meta: {
        title: i18n.t('title.freeGiveaway')
      }
    },
    {
      path: '/appfreeaway',
      name: "appfreeaway",
      component: AppFreeAway,
      meta: {
        title: i18n.t('title.freeGiveaway')
      }
    },
    {
      path: '/appnewplace',
      name: "NewPlace",
      component: AppNewPlace,
      meta: {
        title: i18n.t('title.newPlaceToBuy')
      }
    },
    {
      path: '/apptraderules',
      name: "TradingRules",
      component: AppTradingRules,
      meta: {
        title: i18n.t('title.tradingRules')
      }
    },
    {
      path: '/howcoupon',
      name: "howcoupon",
      component: HowCoupon,
      meta: {
        title: i18n.t('title.getCoupon')
      }
    },
    {
      path: '/appprocess',
      name: "Process introduction",
      component: AppOversea,
      meta: {
        title: i18n.t('title.processIntroduction')
      }
    },
    {
      path: '/apppurchase',
      name: "Process introduction",
      component: AppPurchase,
      meta: {
        title: i18n.t('title.processIntroduction')
      }
    },
    {
      path: '/appactivitydetail',
      name: "Important Update",
      component: AppActivityDetail,
      meta: {
        title: i18n.t('title.importantUpdate')
      }
    },
    {
      path: '/appprocess',
      name: "Process introduction",
      component: AppOversea,
      meta: {
        title: i18n.t('title.processIntroduction')
      }
    },
    // 入驻回调
    {
      path: '/becomeseller/:id?',
      name: "Becomeseller",
      component: BecomeAppSeller,
      meta: {
        title: 'Become a Seller'
      }
    },
    // 入驻回调
    {
      path: '/merchants/:id?',
      name: "Merchants",
      component: Merchants,
      meta: {
        title: 'Become a Seller'
      }
    },
    // // 新人认证回调
    //     {
    //       path: '/authentication',
    //       name: "Authentication",
    //       component: authentication,
    //       meta: {
    //         title: 'ID Verification'
    //       }

    //     },
    // 节日
    {
      path: '/apphoilday/:id?',
      name: "Notice",
      component: AppMidautumn,
      meta: {
        title: i18n.t('base.notice')
      }
    },
    // 活动
    {
      path: '/promotion/:id?',
      name: "Promotion",
      component: Promotion,
      meta: {
        title: i18n.t('base.Promotions')
      }
    },
    // 节日结束
    {
      path: '*',
      name: "404",
      component: NotFind,
      meta: {
        title: "404"
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js